import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Search, Building2 } from "lucide-react";
import { STATUS_COLORS } from "@/lib/constants";

export default function CommandPalette({ open, setOpen }) {
  const [q, setQ] = useState("");
  const [apts, setApts] = useState([]);
  const [results, setResults] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    if (open && apts.length === 0) {
      api.get("/apartments").then((r) => setApts(r.data)).catch(() => {});
    }
    if (!open) setQ("");
  }, [open]);

  useEffect(() => {
    const s = q.trim().toLowerCase();
    if (s.length < 2) { setResults([]); return; }
    setResults(
      apts.filter((a) =>
        `${a.name} ${a.address} ${a.postal_code} ${a.city} ${a.arrondissement || ""} ${a.owner_name || ""}`
          .toLowerCase().includes(s)
      ).slice(0, 8)
    );
  }, [q, apts]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[2000] bg-slate-900/40 backdrop-blur-sm flex items-start justify-center pt-[12vh] px-4"
         onClick={() => setOpen(false)} data-testid="cmdk-overlay">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden"
           onClick={(e) => e.stopPropagation()} data-testid="cmdk-palette">
        <div className="flex items-center gap-2 px-4 border-b border-slate-100">
          <Search className="w-4 h-4 text-slate-400 flex-shrink-0" />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)}
                 placeholder="Rechercher un appartement…"
                 onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
                 className="w-full py-3.5 text-sm outline-none bg-transparent" data-testid="cmdk-input" />
          <kbd className="text-[10px] text-slate-400 border border-slate-200 rounded px-1.5 py-0.5 flex-shrink-0">ESC</kbd>
        </div>
        <div className="max-h-80 overflow-y-auto thin-scroll">
          {results.map((a) => {
            const st = STATUS_COLORS[a.color_status] || STATUS_COLORS.ok;
            return (
              <button key={a.id}
                      onClick={() => { setOpen(false); nav(`/apartments/${a.id}`); }}
                      className="w-full text-left px-4 py-3 hover:bg-slate-50 flex items-start gap-3 transition-colors"
                      data-testid={`cmdk-result-${a.id}`}>
                <span className="w-2.5 h-2.5 rounded-full mt-1.5 flex-shrink-0" style={{ background: st.hex }} />
                <div className="min-w-0">
                  <div className="text-sm font-medium text-slate-900 truncate">{a.name}</div>
                  <div className="text-xs text-slate-500 truncate">{a.address} · {a.city} {a.arrondissement}</div>
                  <div className="text-xs text-slate-400">{a.cleaning_company}{a.referent ? ` · ${a.referent}` : ""}</div>
                </div>
              </button>
            );
          })}
          {q.trim().length >= 2 && results.length === 0 && (
            <div className="px-4 py-8 text-sm text-slate-400 text-center">Aucun appartement trouvé</div>
          )}
          {q.trim().length < 2 && (
            <div className="px-4 py-8 text-sm text-slate-400 text-center">
              Tapez au moins 2 caractères — nom, adresse, code postal, propriétaire…
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
